import React from 'react';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons'

import './loading.scss';

function LoadingComponent() {
    return (
        <div className='loading'>
            <FontAwesomeIcon icon={faSpinner} size={'4x'} pulse />
        </div>
    );
}

export default LoadingComponent;
